export default __webpack_public_path__ + "static/media/habano.e4096891.png";